import { render, staticRenderFns } from "./book.vue?vue&type=template&id=dad7ed22&scoped=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"
import style0 from "./book.vue?vue&type=style&index=0&id=dad7ed22&prod&lang=scss&scoped=true"
import style1 from "./book.vue?vue&type=style&index=1&id=dad7ed22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad7ed22",
  null
  
)

export default component.exports